import React from "react";
import ToggleableSection, { getInitialCollapsed, DEFAULT_ENABLED_KEY } from "../../common/ToggleableSection.jsx";
import TextStyleOptions from "./TextStyleOptions.jsx";

function TextStyleSettings(props) {
  const { title, selectedObject, prefix, enabledKey } = props;
  const initialCollapsed = getInitialCollapsed(selectedObject, prefix, enabledKey || DEFAULT_ENABLED_KEY);
  return (
    <ToggleableSection {...props} initialCollapsed={initialCollapsed} title={title}>
      <TextStyleOptions {...props} disabled={initialCollapsed} />
    </ToggleableSection>
  )
}

export default TextStyleSettings;